import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { Utils } from 'Utils/utils';
import HubspotForm from 'react-hubspot-form';
import * as CONSTANTS from 'Utils/constants';
import { CommonPopupWithImageComponent } from 'Components/common/commonPopupWithImageComponent';
import { LoadingWrapper } from './loadingWrapper';

class RequestQuoteFormPopupState {
  @observable showRequestQuoteForm = false;

  @action
  setShowRequestQuoteForm(val = false) {
    this.showRequestQuoteForm = val;
  }
}
const requestQuoteFormPopupState = new RequestQuoteFormPopupState();

const RequestQuoteFormPopup = observer(props => {
  const [
    showFormSubmissionMessage,
    setShowFormSubmissionMessage,
  ] = React.useState(false);

  const closePopup = () => {
    Utils.removeBusinessEmailFromUrl();
    requestQuoteFormPopupState.setShowRequestQuoteForm(false);
  };

  const hubspotSuccessCallback = (formData = []) => {
    Utils.mixpanelTrack(
      CONSTANTS.MX_TRIAL_ONBOARDING.CLICK_LB_TRIAL_UPGRADE_NOW_FORM_FILL,
      {},
    );
    setShowFormSubmissionMessage(true);
  };

  const closeSubmissionMsgPopup = () => {
    setShowFormSubmissionMessage(false);
    closePopup();
  };

  const description = (
    <>
      An Adapt expert will reach out to you shortly. If you have any prior
      questions please write to us at{' '}
      <a href="mailto:support@adapt.io">support@adapt.io</a>
    </>
  );

  const FormSubmissionMsg = () => {
    return (
      <CommonPopupWithImageComponent
        svgImgComponent=""
        customParentClass="credit-upgrade-popup"
        titleText="Awesome! Help is on the way."
        description={description}
        btnText="Ok"
        actionBtnCallback={closeSubmissionMsgPopup}
        clickOutsidePopupCallback={closeSubmissionMsgPopup}
        closeClickCallback={closeSubmissionMsgPopup}
        showCloseBtn
      />
    );
  };

  const HSFormWrapper = () => {
    return (
      <div className="hubspot-form">
        <HubspotForm
          portalId={CONSTANTS.HUBSPOT_PORTAL_ID}
          formId={CONSTANTS.REQUEST_QUOTE_FORM}
          inlineMessage="Please select a comfortable time for our expert to help you with a custom plan."
          onSubmit={formData => {
            setTimeout(() => {
              hubspotSuccessCallback(formData);
            }, 250);
          }}
          onReady={form => {
            console.log('Form ready!');
            setTimeout(() => {
              Utils.removeBusinessEmailFromUrl();
            }, 500);
          }}
          loading={
            <div className="loading-icon">
              <LoadingWrapper show />
            </div>
          }
        />
      </div>
    );
  };

  return requestQuoteFormPopupState.showRequestQuoteForm ? (
    <>
      {showFormSubmissionMessage ? (
        <FormSubmissionMsg />
      ) : (
        <div className="pricingPopup common-popup requestQuoteHubSpotForm">
          <div className="pricing-popup-overlay" onClick={e => closePopup()} />
          <div className="pricing-popup">
            <div className="title">Help us with your requirement</div>
            <div className="desc-content">
              We are happy to help you get started with Adapt
            </div>
            <HSFormWrapper />
          </div>
        </div>
      )}
    </>
  ) : (
    ''
  );
});

export { RequestQuoteFormPopup, requestQuoteFormPopupState };
export default RequestQuoteFormPopup;
